<script>
import IndicatorGroup from './IndicatorGroup.vue'

export default {
  name: 'IndicatorsPanel',
  components: {
    IndicatorGroup,
  },
  props: {
    dataSource: {
      type: Object,
      default: () => null,
    },
    indicatorsInCategory: {
      type: Array,
      required: true,
    },
  },
  emits: [
    'selectedIndicatorsUpdated',
  ],
  data () {
    return {
      selectableIndicators: [],
    }
  },
  computed: {
    selectedIndicators () {
      return this.selectableIndicators.flatMap(category => category.indicators).filter(indicator => indicator.selected)
    },
    displayedResolution () {
      return this.dataSource && this.dataSource.resolution ? this.dataSource.resolution : ''
    },
  },
  watch: {
    indicatorsInCategory: {
      handler(indicatorsInCategory) {
        if (indicatorsInCategory !== undefined) {
          this.selectableIndicators = indicatorsInCategory.map(category => ({
            ...category,
            indicators: category.indicators.map(indicator => ({
              ...indicator,
              selected: true,
            })),
          }))
        }
      },
      immediate: true,
    },
    selectedIndicators () {
      this.$emit('selectedIndicatorsUpdated', this.selectedIndicators)
    },
  },
  methods: {
    setIcon(category) {
      if (category.toLowerCase().includes('temperature')) {
        return 'fas fa-temperature-low'
      }
      return 'fas fa-cloud-showers-heavy'
    },
  },
}
</script>
<template>
  <div class="data-panel">
    <div class="data-panel-title">
      {{ $gettext('Indicators') }}
      <span v-if="displayedResolution">
        ({{ $gettext('Resolution') }} {{ $gettext(':') }} {{ displayedResolution }})
      </span>
    </div>
    <div
      class="data-panel-content"
    >
      <IndicatorGroup
        v-for="category of selectableIndicators"
        :key="category.name"
        :name="$gettext(category.name)"
        :icon="setIcon(category.name)"
        :indicators="category.indicators"
      />
    </div>
  </div>
</template>
<style lang="scss" scoped>
.data-panel-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>
